import { render } from "./HeroWithImageBackground.vue?vue&type=template&id=236bd305"
import script from "./HeroWithImageBackground.vue?vue&type=script&lang=js"
export * from "./HeroWithImageBackground.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__